module.exports = __webpack_public_path__ + "img/type13.27ab1d66.png";